import React from 'react';
import { Camera, Heart, Sparkles, Clock } from 'lucide-react';

const AboutSection = () => {
  return (
    <section id="about" className="perf-section py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left: Content */}
          <div className="space-y-6">
            <span className="text-sm uppercase tracking-widest text-gray-500 font-medium">About Us</span>
            <h2 className="text-5xl md:text-6xl font-bold text-gray-900 leading-tight">
              Capturing Love,
              <br />
              One Frame at a Time
            </h2>
            <div className="space-y-4 text-lg text-gray-600 leading-relaxed">
              <p>
                With over 10 years of experience in wedding photography, we specialize in capturing
                the authentic emotions and timeless moments that make your special day unforgettable.
              </p>
              <p>
                Our approach combines artistic vision with documentary storytelling, ensuring that
                every laugh, tear, and embrace is preserved in stunning detail.
              </p>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-2 gap-8 pt-8">
              <div className="space-y-2">
                <div className="text-4xl font-bold text-gray-900">500+</div>
                <div className="text-sm text-gray-600 uppercase tracking-wider">Weddings Captured</div>
              </div>
              <div className="space-y-2">
                <div className="text-4xl font-bold text-gray-900">10+</div>
                <div className="text-sm text-gray-600 uppercase tracking-wider">Years Experience</div>
              </div>
            </div>
          </div>

          {/* Right: Features */}
          <div className="space-y-6">
            <div className="bg-gray-50 p-8 rounded-2xl space-y-4">
              <div className="w-12 h-12 bg-gray-900 rounded-lg flex items-center justify-center">
                <Camera className="w-6 h-6 text-white" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900">Professional Equipment</h3>
              <p className="text-gray-600">
                We use state-of-the-art cameras and lenses to ensure the highest quality images in any lighting condition.
              </p>
            </div>

            <div className="bg-gray-50 p-8 rounded-2xl space-y-4">
              <div className="w-12 h-12 bg-gray-900 rounded-lg flex items-center justify-center">
                <Heart className="w-6 h-6 text-white" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900">Personalized Approach</h3>
              <p className="text-gray-600">
                Every couple is unique, and we tailor our style to match your vision and personality.
              </p>
            </div>

            <div className="bg-gray-50 p-8 rounded-2xl space-y-4">
              <div className="w-12 h-12 bg-gray-900 rounded-lg flex items-center justify-center">
                <Sparkles className="w-6 h-6 text-white" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900">Artistic Excellence</h3>
              <p className="text-gray-600">
                Award-winning photography that combines technical skill with creative artistry.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
